module.exports = require('./_global');


//////////////////
// WEBPACK FOOTER
// /var/www/umem/~/core-js/modules/_path.js
// module id = 293
// module chunks = 0